module.exports = __webpack_public_path__ + "img/ivo.a2f7cbb9.png";